import './app.css';
import 'isomorphic-fetch';
import {TweenMax} from 'gsap';

import '@babel/polyfill';


/* analytics */
const analyticsEvent = require('./js/viscom/viscomjs/analytics/analyticsEvent');
analyticsEvent('Page', 'load', 'Start');

/* is production */
const isProd = process.env.NODE_ENV === 'production';

/* meta */
import meta from './js/meta.json';

/* data [UNCOMMENT THE LINE BELOW TO USE TEXTS FROM DATA IN JS] */
// import data from './js/data.json';



require('./js/viscom/viscomjs/analytics/elementsTracking');
// Could be actualized by method update:
// elementsTracking.update();



/* fonts */
import WebFont from 'webfontloader';

WebFont.load({
    // CUSTOM FONTS
    custom: {
        families: ['Museo Sans Cyrl:cyrillic,cyrillic-ext,latin-ext', 'Futura PT:cyrillic,cyrillic-ext,latin-ext'],
        urls: ['./css/fonts.css']
    },
    // GOOGLE FONTS
    google: {
        families: ['Roboto:300,700:cyrillic,cyrillic-ext,latin-ext']
    }
});



/* share */
const ShareButtons = require('./js/viscom/viscomjs/ui/ShareButtons');
ShareButtons(meta, '.share__button');

{
    const startProject = () => {

        const preloader = require('./js/viscom/kaspersky/risksOverview/load/Preloader');
        // const videoBg = require('./js/viscom/kaspersky/risksOverview/videoBg');
        // const coverVideoBg = require('./js/viscom/kaspersky/risksOverview/coverVideoBg');
        const SizeMode = require('./js/viscom/kaspersky/risksOverview/utils/SizeMode');
        const msgEl = document.querySelector('[data-mobile-message]');
        let constructor;
        let delay = isProd ? 4000 : 1000;

        const sizeMode = SizeMode();
        if (sizeMode === 'mobile_landscape' || sizeMode === 'mobile_portrait') {
            constructor =  require('./js/viscom/kaspersky/risksOverview/utils/DisplayMobileMessage');
            constructor(msgEl);

            delay = isProd ? 6000 : 1000;
        }

        constructor = require('./js/viscom/kaspersky/risksOverview/PreviewIllustration');
        const previewIlln = constructor(document.querySelector('.preview')).init().resize(sizeMode);
        const startLoadTime = new Date().getTime();

        const ProjectPreload = require('./js/viscom/kaspersky/risksOverview/load/ProjectPreload');

        const loaded = () => {
            const t = new Date().getTime();
            const Project = require('./js/viscom/kaspersky/risksOverview/ProjectSingleton');
            preloader.update({
                progress: 100
            });
            TweenMax.delayedCall(Math.max(0, delay - (t - startLoadTime)) / 1000, () => {
                Project.init();
                TweenMax.delayedCall(0.01, () => {
                    Project.start();
                    preloader.destroy();
                    TweenMax.delayedCall(1, () => {
                        if (msgEl.parentNode) msgEl.parentNode.removeChild(msgEl);
                    });
                });
            });
        };

        previewIlln.show();
        // coverVideoBg.startcover();
        // videoBg;
        // videoBg.start();

        ProjectPreload(preloader.update)
            .then(loaded);

    };

    startProject();
}

/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}





// WEBPACK FOOTER //
// ./app.js